/* Kauve&Co. theme behaviour — cart drawer, menus, variants, quick add */
(function () {
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  /* ---------- Drawers ---------- */
  function openDrawer(el) {
    if (!el) return;
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const focusable = el.querySelector('button, a, input');
    if (focusable) focusable.focus();
  }
  function closeDrawer(el) {
    if (!el) return;
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (event) {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')));
    }
    const closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') $$('.drawer[aria-hidden="false"]').forEach(closeDrawer);
  });

  /* ---------- Search toggle ---------- */
  const searchToggle = $('[data-search-toggle]');
  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      const bar = $('#search-bar');
      if (!bar) return;
      bar.hidden = !bar.hidden;
      if (!bar.hidden) { const i = $('input[name="q"]', bar); if (i) i.focus(); }
    });
  }

  /* ---------- Cart ---------- */
  function updateCartUI(cart) {
    const count = cart.item_count;
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    return fetch(window.Shopify && window.Shopify.routes ? '/?section_id=cart-drawer' : '/?section_id=cart-drawer')
      .then((r) => r.text())
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-contents]');
        const current = document.querySelector('[data-cart-contents]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Cart request failed');
        return data;
      });
    });
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then(updateCartUI);
  }

  /* add to cart (product form + quick add) */
  document.addEventListener('submit', function (event) {
    const form = event.target.closest('form[data-cart-add], form.js-cart-add');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const label = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    const formData = new FormData(form);
    const payload = { items: [{ id: formData.get('id'), quantity: Number(formData.get('quantity') || 1) }] };
    cartRequest('/cart/add.js', payload)
      .then(refreshCart)
      .then(function () { openDrawer(document.getElementById('cart-drawer')); })
      .catch(function (error) { alert(error.message); })
      .finally(function () { if (button) { button.disabled = false; button.textContent = label; } });
  });

  /* quantity change / remove in cart drawer & cart page */
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-cart-change]');
    if (!btn) return;
    event.preventDefault();
    const line = Number(btn.getAttribute('data-line'));
    const quantity = Number(btn.getAttribute('data-cart-change'));
    const container = document.querySelector('[data-cart-contents]');
    if (container) container.classList.add('loading');
    cartRequest('/cart/change.js', { line: line, quantity: quantity })
      .then(updateCartUI)
      .catch(function (error) { alert(error.message); })
      .finally(function () { if (container) container.classList.remove('loading'); });
  });

  document.addEventListener('change', function (event) {
    const input = event.target.closest('[data-cart-qty-input]');
    if (!input) return;
    cartRequest('/cart/change.js', { line: Number(input.getAttribute('data-line')), quantity: Number(input.value) })
      .then(updateCartUI)
      .catch(function (error) { alert(error.message); });
  });

  /* simple quantity steppers (product page, not cart) */
  document.addEventListener('click', function (event) {
    const step = event.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input');
    if (!input) return;
    const next = Number(input.value || 1) + Number(step.getAttribute('data-qty-step'));
    input.value = Math.max(1, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', function (event) {
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-gallery]');
    const main = gallery.querySelector('[data-gallery-main]');
    const img = thumb.querySelector('img');
    if (main && img) { main.src = img.getAttribute('data-full') || img.src; main.alt = img.alt; }
    $$('[data-gallery-thumb]', gallery).forEach((t) => t.setAttribute('aria-current', 'false'));
    thumb.setAttribute('aria-current', 'true');
  });

  /* ---------- Variant selection ---------- */
  $$('[data-variant-picker]').forEach(function (picker) {
    const form = document.getElementById(picker.getAttribute('data-form'));
    const variants = JSON.parse(picker.querySelector('[data-variant-json]').textContent);
    picker.addEventListener('change', function () {
      const chosen = $$('input:checked', picker).map((i) => i.value);
      const match = variants.find(function (v) {
        return v.options.every(function (opt, index) { return opt === chosen[index]; });
      });
      const idField = form.querySelector('[name="id"]');
      const submit = form.querySelector('[type="submit"]');
      const priceEl = document.querySelector('[data-variant-price]');
      if (match) {
        idField.value = match.id;
        if (priceEl) priceEl.innerHTML = match.price_html;
        submit.disabled = !match.available;
        submit.textContent = match.available ? submit.getAttribute('data-add-label') : submit.getAttribute('data-sold-label');
        const url = new URL(window.location);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      } else {
        submit.disabled = true;
        submit.textContent = submit.getAttribute('data-sold-label');
      }
    });
  });

  /* ---------- Collection filter/sort auto submit ---------- */
  $$('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () { el.closest('form').submit(); });
  });

  /* ---------- Scroll reveal ---------- */
  if ('IntersectionObserver' in window && matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('reveal'); observer.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    $$('[data-reveal]').forEach((el) => observer.observe(el));
  }
})();
